import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { useEffect, useState } from "react";
import { RecordingRulesFormValues } from "src/models/RecordingRules.model";
import {
  useGetRecordingRulesByIdQuery,
  useUpdateRecordingRulesMutation,
} from "src/services/RecordingRulesServices";
import { showToast } from "src/utils/showToaster";
import { object } from "yup";
import RecordingRulesForm from "../Layout/RecordingRulesForm";
import { formatedDateTimeIntoIst } from "src/utils/formUtils/dateTimeFormate";

type Props = {
  onClose: () => void;
  recordingRuleId: string;
};

const EditRecordingRulesFormWrapper = ({
  onClose,
  recordingRuleId = "",
}: Props) => {
  const [recordingRulesData, setRecordingRulesData] = useState<any>(null);

  const { data, isLoading, isFetching } =
    useGetRecordingRulesByIdQuery(recordingRuleId);
  const [updateRecordingRules] = useUpdateRecordingRulesMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setRecordingRulesData(data?.data || null);
    }
  }, [data, isLoading, isFetching]);
  // Form Initial Values
  const initialValues: RecordingRulesFormValues = {
    batchId: {
      _id: recordingRulesData?.batchId,
      batchName: recordingRulesData?.batchName,
    },
    studentIds: recordingRulesData?.studentIds?.map((student: any) => {
      return {
        label: student?.name,
        value: student?._id,
      };
    }),
    startDate: recordingRulesData?.startDate || null,
    endDate: recordingRulesData?.endDate || null,
    radio: recordingRulesData?.status,
    always: recordingRulesData?.endDate === "*" ? true : false,
  };

  // Validation Schema
  const validationSchema = object().shape({});

  // Handle Submit
  const handleSubmit = (
    values: RecordingRulesFormValues,
    { setSubmitting, resetForm }: FormikHelpers<RecordingRulesFormValues>
  ) => {
    const formattedValues = {
      // batchId: values?.batchId?._id,
      // studentIds: values?.studentIds?.map((student: any) => student?.value),
      // allowedDate: {
      //   startDate:
      //     values?.radio === "ALLOWLED"
      //       ? values?.always
      //         ? "*"
      //         : values?.startDate
      //       : null,
      //   endDate:
      //     values?.radio === "ALLOWLED"
      //       ? values?.always
      //         ? "*"
      //         : values?.endDate
      //       : null,
      // },
      // deniedDate: {
      //   startDate:
      //     values?.radio === "DENIED"
      //       ? values?.always
      //         ? "*"
      //         : values?.startDate
      //       : null,
      //   endDate:
      //     values?.radio === "DENIED"
      //       ? values?.always
      //         ? "*"
      //         : values?.endDate
      //       : null,
      // },
      // priority: values?.priority,
      status: values?.radio,
      startDate: values?.startDate
        ? formatedDateTimeIntoIst(values?.startDate, "YYYY-MM-DD")
        : "*",
      endDate: values?.endDate
        ? formatedDateTimeIntoIst(values?.endDate, "YYYY-MM-DD")
        : "*",
      batchId: values?.batchId?._id,
      studentIds: values?.studentIds?.map((student: any) => student?.value),
      priority: values?.radio === "DENIED" ? 2 : 1,
    };
    updateRecordingRules({
      body: formattedValues,
      id: recordingRuleId,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="sm" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <RecordingRulesForm
              formikProps={formikProps}
              onClose={onClose}
              isLoading={isLoading || isFetching}
              formType="EDIT"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditRecordingRulesFormWrapper;
